import { Injectable } from '@angular/core';
import { LongTextDTOModal, LongTextEditorComponent } from '../../components/forms/longTextEditor.component';
import { DynamicDialogConfig } from 'primeng-lts/dynamicdialog';
import { PlycaDataService } from '../../../services/plyca.service';
import { getSimpleIdentifierFromString } from '../../api/plyca-dtos';

@Injectable()
export class AYMADContractModificationValidations {
  dialogService: any;

  static isFrameworkAgremeent(model: any) {
    let isFrameworkAgreement = false;
    if (model?.procurementProjectInfo?.complementarySystem !== undefined &&
      model?.procurementProjectInfo?.complementarySystem?.identifier === 'AM<>SISTCOMPLEMENTARIO') {
      isFrameworkAgreement = true;
    }
    return isFrameworkAgreement;
  }

  static initCumulativePriceVariation(model: any) {
    AYMADContractModificationValidations.calculateCumulativePriceVariation(model);
  }


  private static isBasedContract(model: any) {
    let isBasedContract = false;
    if (model?.procurementProjectInfo?.complementarySystem !== undefined &&
      model?.procurementProjectInfo?.complementarySystem?.identifier === 'CBAM<>SISTCOMPLEMENTARIO') {
      isBasedContract = true;
    }
    return isBasedContract;
  }

  private static roundDecimals(value: number, decimals?: number): number {
    let digits: number = (decimals || decimals === 0) ? decimals : 2;
    let multiplier = Math.pow(10, digits);
    return Math.round((value + Number.EPSILON) * multiplier) / multiplier;
  }

  private static calculateTotalAmount(model: any) {
    if (model?.budget?.amountExcludingTaxes !== undefined && model?.budget?.totalTaxes !== undefined) {
      model.budget.totalAmount = model.budget.amountExcludingTaxes + model.budget.totalTaxes;
      model.budget.totalAmount = this.roundDecimals(model.budget.totalAmount, 2);
    } else if (model?.budget?.amountExcludingTaxes !== undefined) {
      model.budget.totalAmount = model.budget.amountExcludingTaxes;
    } else if (model?.budget?.totalTaxes !== undefined) {
      model.budget.totalAmount = model.budget.totalTaxes;
    } else {
      model.budget.totalAmount = 0.0;
    }
  }

  private static calculatePriceVariation(model: any) {
    if (model.budget) {
      let awardAmountExcludingTaxes = Math.abs(model.contractModificationLot.awardLot.amountwithoutTax);
      let amountExcludingTaxes = Math.abs(model.budget.amountExcludingTaxes);
      if (amountExcludingTaxes === undefined) {
        awardAmountExcludingTaxes = 0.0;
      }
      model.budget.priceVariation = (amountExcludingTaxes * 100) / awardAmountExcludingTaxes;
    } else {
      model.budget.priceVariation = 0.0;
    }
  }

  private static calculateCumulativePriceVariation(model: any) {
    if (model.budget && model.isEconomicContractModification !== undefined && model.isEconomicContractModification) {
      let awardAmountExcludingTaxes = 0;
      if (model?.contractModificationLot?.awardLot !== undefined && model.contractModificationLot.awardLot.amountwithoutTax !== undefined) {
        awardAmountExcludingTaxes = Math.abs(model.contractModificationLot.awardLot.amountwithoutTax);
      }
      let amountExcludingTaxes = 0;
      if (model.budget?.amountExcludingTaxes !== undefined) {
        amountExcludingTaxes = Math.abs(model.budget.amountExcludingTaxes);
      }
      let amountApprovedContractModifications = 0;
      // if (model?.context?.configurations?.amountApprovedContractModifications !== undefined) {
      if (model.budget.amountApprovedContractModifications !== undefined) {
        // amountApprovedContractModification = Math.abs(model.context.configurations.amountApprovedContractModifications.value);
        amountApprovedContractModifications  = Math.abs(model.budget.amountApprovedContractModifications);
      }
      if (awardAmountExcludingTaxes !== 0) {
        model.budget.cumulativePriceVariation =
            ((amountExcludingTaxes + amountApprovedContractModifications) / awardAmountExcludingTaxes) * 100;
      } else {
        model.budget.cumulativePriceVariation = 0;
      }
      /*model.budget.cumulativePriceVariation =
        ((amountExcludingTaxes + amountApprovedContractModification) / awardAmountExcludingTaxes) * 100;*/
    } else {
      model.budget.cumulativePriceVariation = 0.0;
    }
  }

  static isExemptTaxType(model: any) {
    let result = false;
    if ('0<>TIPO_IMPUESTO' === model?.budget?.taxType?.identifier) {
      result = true;
      model.budget.totalTaxes = null;
    }
    return result;
  }

  public isACompensation(model: any) {
    let result = false;
    if ('A<>TIPO_INDEMNIZACION' === model?.compensation?.identifier) {
      result = true;
    }
    if (!result && model?.plannedPeriod?.requestDate != null) {
      model.plannedPeriod.requestDate = null;
    }
    return result;
  }

  public isSundryTaxTypes(model: any) {
    let result = false;
    if ('998<>TIPO_IMPUESTO' === model?.budget?.taxType?.identifier) {
      result = true;
    }
    return result;
  }

  public getTextCompanySBC(model: any) {
    let text = '';
    if (model.company !== undefined && model.company.taxIdentifier !== undefined) {
      text = model.company ?
        (model.company.taxIdentifier + ' - ' +
          (model.company.name ? model.company.name : (model.company.commercialName ? model.commercialName : '')))
        : '';
    }
    return text;
  }


  public getIdentifierParentCauses(model: any) {
    // 000130<>CAUSAS_INCIDENCIA
    if (model.cause && model.cause.generalCauses !== undefined && model.cause.generalCauses.length > 0) {
      return '000162<>CAUSAS_INCIDENCIA'
    } else {
      return 'NULO'; // Parametro especifico para el buscador.
    }
  }

  public visibleStartDateSSC(model: any) {
    let existStartDate = model.plannedPeriod !== undefined && model.plannedPeriod.startDate !== undefined;
    return existStartDate;
  }

  public visibleEndDateSSC(model: any) {
    let existStartDate = model.plannedPeriod !== undefined && model.plannedPeriod.endDate !== undefined;
    return existStartDate;
  }




  constructor(
    public plycaService: PlycaDataService
  ) {
  }

  public isBasedContract(model: any) {
    return AYMADContractModificationValidations.isBasedContract(model);
  }

  public isFrameworkAgremeent(model: any) {
    return AYMADContractModificationValidations.isFrameworkAgremeent(model);
  }

  public isFrameworkAgremeentTable(model: any) {
    return AYMADContractModificationValidations.isFrameworkAgremeent(model._parent);
  }

  public isFrameworkAgremeentEditor(model: any) {
    return AYMADContractModificationValidations.isFrameworkAgremeent(model._parent);
  }

  public visibleDataContractExtensionType0(model: any) {
    return model?.contractExtension !== undefined && model?.contractExtension !== null
     && model.contractExtension.identifier === '0<>TIPO_PRORROGA';
  }

  public visibleDataContractExtensionType1(model: any) {
    let isBasedContract = AYMADContractModificationValidations.isBasedContract(model);
    return !isBasedContract && model?.contractExtension !== undefined && model?.contractExtension !== null
    && model.contractExtension.identifier === '1<>TIPO_PRORROGA';
  }

  public isExemptTaxType(model: any) {
    return AYMADContractModificationValidations.isExemptTaxType(model);
  }

  public setTextDurationDesc(model: any) {
    let isFrameworkAgreement = AYMADContractModificationValidations.isFrameworkAgremeent(model);
    if (model?.contractExtension !== undefined && model?.contractExtension !== null
      &&  model.contractExtension.identifier === '1<>TIPO_PRORROGA') {
      if (isFrameworkAgreement) {
        model.plannedPeriod.durationDesc = 'Hasta el inicio de la ejecución del nuevo acuerdo marco, con un máximo de nueve meses.';
      } else {
        model.plannedPeriod.durationDesc = 'Hasta el inicio de la ejecución del nuevo contrato, con un máximo de nueve meses.';
      }
    }
  }

  public isApportioned(model: any) {
    let apportioned = false;
    if (model?.procurementProjectInfo !== undefined &&
      model?.procurementProjectInfo?.apportioned) {
      apportioned = true;
    }
    return apportioned;
  }

  setTotalAmount(model: any) {
    AYMADContractModificationValidations.calculateTotalAmount(model);
  }

  public visibleTaxRate(model: any) {
    return model?.budget?.taxType !== undefined && model.budget.taxType.identifier === '998<>TIPO_IMPUESTO';
  }

  public editableTaxRate(model: any) {
    if (model?.budget?.taxType !== undefined &&
      model.budget.taxType.identifier === '0<>TIPO_IMPUESTO') {
      model.budget.totalTaxes = undefined;
    }
    return model?.budget?.taxType !== undefined && model.budget.taxType.identifier !== '0<>TIPO_IMPUESTO';
  }

  public visibleAMPType0(model: any) {
    return model?.type !== null && model?.type !== undefined && model?.type.identifier === '0<>TIPO_AMPLIACION';
  }

  public isPNCType0(model: any) {
    return model?.type !== null && model?.type !== undefined && model?.type.identifier === '0<>TIPO_PENALIDAD';
  }

  public isPNCType1(model: any) {
    return model?.type !== null && model?.type !== undefined && model?.type.identifier === '1<>TIPO_PENALIDAD';
  }

  public specificCauseVisible(model: any) {
    if (model.cause && model.cause.generalCause && model.cause.generalCause.identifier === '000130<>CAUSAS_INCIDENCIA') {
      return true;
    }
    return false;
  }

  public isEconomicMDC(model: any) {
    let isEconomicMDC = model.isEconomicContractModification !== undefined && model.isEconomicContractModification;
    return isEconomicMDC;
  }

  public isDurationMDC(model: any) {
    let isDurationMDC = model.isDurationContractModification !== undefined && model.isDurationContractModification;
    return isDurationMDC;
  }

  public clearDurationDataMDC(model: any) {
    let isDurationMDC = model.isDurationContractModification !== undefined && model.isDurationContractModification;
    if (!isDurationMDC) {
      model.auxField = undefined;
      if (model.plannedPeriod !== undefined) {
        model.plannedPeriod.duration = undefined;
        model.plannedPeriod.durationUnit = undefined;
      }

    }
  }

  public calculateAmountsMDC(model: any) {
    AYMADContractModificationValidations.calculateTotalAmount(model);
    AYMADContractModificationValidations.calculatePriceVariation(model);
    AYMADContractModificationValidations.calculateCumulativePriceVariation(model);
  }

  public onChangeTaxType(model: any) {
    let emptyTaxType = AYMADContractModificationValidations.isExemptTaxType(model);
    if (emptyTaxType && model?.budget?.totalTaxes !== undefined) {
      model.budget.totalTaxes = 0.0;
      AYMADContractModificationValidations.calculateTotalAmount(model);
    }
  }

  public getProjectIdentifier(model: any) {
    let dossierId = '';
    if (model?.division?.parent?.project?.identifier !== undefined) {
      dossierId = model.division.parent.project.identifier;
    }
    return dossierId;
  }

  public getContractModificationDivision(model: any) {
    let division = '-1';
    if (model?.division?.identifier !== undefined) {
      division = model.division.identifier;
    }
    return division;
  }

  public isWorks(model: any) {
    let isWorks = false;
    if (model?.procurementProjectInfo?.typeCode !== undefined &&
      model?.procurementProjectInfo?.typeCode?.identifier === '01<>TIPOEXPTE') {
      isWorks = true;
    }
    return isWorks;
  }

  public getTextTableBudgetAccountLines(model: any) {
    let isFrameworkAgreement = AYMADContractModificationValidations.isFrameworkAgremeent(model);
    if (isFrameworkAgreement) {
      return 'Imputación Presupuestaria';
    } else {
      return 'Financiación';
    }
  }

  public isRJA(model: any) {
    return model.increaseDecrease_aymad !== undefined && model.increaseDecrease_aymad !== null
    && model?.increaseDecrease_aymad.identifier === '2<>TIPO_MDC_ECONOMICA_AYMAD';
  }

  public visibilityTittleEconomicData(model: any) {
    let isFrameworkAgreement = AYMADContractModificationValidations.isFrameworkAgremeent(model);
    let isEconomicMDC = model.isEconomicContractModification !== undefined && model.isEconomicContractModification;
    let apportioned = false;
    if (model?.procurementProjectInfo !== undefined &&
      model?.procurementProjectInfo?.apportioned) {
      apportioned = true;
    }
    return isEconomicMDC || apportioned;
  }

  public isVisibleColumnDateAntecedent(model: any) {
    return true;
  }

  public clearForm(model: any) {
    if (model?.plannedPeriod != null) {
      model.plannedPeriod.delateDays = null;
    }
    if (model?.budget != null) {
      model.budget.amountDay = null;
      model.budget.totalAmount = null;
    }
    if (model?.cause != null) {
      model.cause.generalCauses = null;
    }
    if (model?.determinationBreach != null) {
      model.determinationBreach = null;
    }
  }

  public calculateTotalPNC(model: any) {
    let total = 0;

    // Estaría bien llamar al this.isPNCType0 en lugar de repetir su código pero no funciona
    if (!(model?.type !== null && model?.type !== undefined && model?.type.identifier === '0<>TIPO_PENALIDAD')) {
      total = null;
    } else if (model?.plannedPeriod?.delateDays != null && model?.budget?.amountDay != null) {
      total = model.plannedPeriod.delateDays * model.budget.amountDay;
    }

    return total;
  }

  // SCN
  public visibleAdjustTenderSCN(model: any) {
    let visible = model?._parent?.procurementProjectInfo?.obligationSubcontract !== undefined
    ? model._parent.procurementProjectInfo.obligationSubcontract : false;
    return visible;
  }

  // RVP
  public viewFormRevPrice(model: any) {

    let context = new LongTextDTOModal('', '', true
    );
    let config: DynamicDialogConfig = {
      header: 'Detalle de la Fórmula',
      width: '50%',
      styleClass: 'formEdition'
    };
    context.label = 'Fórmula';
    let article = (model.formulaId && model.formulaId.properties) ? (model.formulaId.properties.TEXTO_FORMULA) : '';
    context.text = article;
    config['context'] = context;
    const ref = this.dialogService.open(LongTextEditorComponent, config);

    // this.showDetailFormRevPrice = true;
  }

  // SSC
  public editableRequestDateSSC(model: any) {
    let editable = false;
    editable = model?.instanceType !== undefined && model?.instanceType?.identifier === 'Contratista<>TIPO_INSTANCIA';
    return editable;
  }

  public clearRequestDateSSC(model: any) {
    if (model?.instanceType === undefined || (model?.instanceType !== undefined &&  model?.instanceType?.identifier !== 'Contratista<>TIPO_INSTANCIA')) {
      model.plannedPeriod.requestDate = undefined;
    }
  }

  public editableTypeSSC(model: any) {
    let editable = false;
    editable = model?.plannedPeriod?.durationType !== undefined && model?.plannedPeriod?.durationType.identifier === 'T<>TIPO_DURACION_SUSPENSION';
    return editable;
  }

  public clearTypeSSC(model: any) {
    if (model?.plannedPeriod?.durationType === undefined ||  (model?.plannedPeriod?.durationType !== undefined
      && model?.plannedPeriod?.durationType.identifier !== 'T<>TIPO_DURACION_SUSPENSION')) {
        model.type = undefined;
      }
  }


  public getPriceRevisionFormulaDesc(model: any) {
    if (model !== undefined && model.formulaId !== undefined && model.formulaId.properties !== undefined) {
      let idFormula = model.formulaId.properties['NUM_FORMULA'];
      let descFormula = model.formulaId.properties['DESC_FORMULA'];
      return idFormula + '.' + descFormula;
    } else {
      return model?.formulaId?.description;
    }
  }

  public filtraCausaPNC(model: any) {
    let scheduleSubrogation = false;
    let isServices = false;
    if (model != null) {
      if (model?.procurementProjectInfo !== undefined &&
        model?.procurementProjectInfo?.scheduleSubrogation) {
          scheduleSubrogation = true;
      }
      if (model?.procurementProjectInfo?.typeCode !== undefined &&
        model?.procurementProjectInfo?.typeCode?.identifier === '04<>TIPOEXPTE') {
          isServices = true;
      }
    }
    if (!isServices || (isServices && !scheduleSubrogation)) {
      return 1;
    } else {
      return 0;
    }
  }


}

